import { Component, OnInit } from '@angular/core';
import { ConnectionService } from '../../connection.service';
import { BackendUrl } from '../../../backendUrl';
import { map } from "rxjs/operators";
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-contracts',
  templateUrl: './contracts.component.html',
  styleUrls: ['./contracts.component.css']
})
export class ContractsComponent implements OnInit {
  transactions = []; transVerify = []; token = localStorage.getItem('Sastana_Token');
  contractList: any ;
  contractCount: any;
  dep :number = 1
  topContract: any;
  searchObj : any = {
    contract : ''
  }
  contractList1: any;
  constructor(private conn: ConnectionService,private alert: ToastrService,private spinner: NgxSpinnerService) { }

  ngOnInit() {
    setTimeout(()=>
    {
      this.getContract();
      this.getcount();
      this.top3Contracts();
      this.YesterContract()
    },1000)

  }

  getContract(contractValue? :any) {
    this.spinner.show()
    this.conn.postUrl('vote/contractList',{searchTerm : contractValue}).subscribe((res: any) => {
      this.spinner.hide()
      this.contractList = res.data
    });
  }

  top3Contracts(){
    this.conn.postUrl('users/topContract',{}).subscribe((res: any) => {
      this.topContract = res.data
    });
  }

  YesterContract(){
    this.conn.postUrl('users/24hrContract',{}).subscribe((res: any) => {
      // this.topContract = res.data
    });
  }

  searchContract(contractValue?:any){
    this.conn.postUrl('users/searchContract',{searchTerm : contractValue}).subscribe((res: any) => {
        this.contractList1 = res.data
    });
  }

  getcount() {
    this.conn.postUrl('users/deployCount', {}).subscribe((res: any) => {
      this.contractCount = res.data
    })
  }

  copyText(val: string) {
    let selBox = document.createElement('input');
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.alert.success('Copied to the clipboard');
  }
}
